import { authFetch } from "../authFetch";


export const getTrainerByTestType = async (requestData) => {
  try {
    const res = await authFetch(`route2.0/trainer-by-test-type-branch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify( requestData ),
    });

    const data = await res.json();
    return data;
  } catch (err) {
    console.error(err);
  }
};
